import {
    clearAuxResourceName,
    clearAuxResourceUrl,
    clearExperienceMarker,
    clearMapBounds,
    setExperienceMarker
} from "./commit_helpers";

// Use this function when an ExperienceMarker is selected - could be via a user action (click) or something else.
export function selectExperienceMarker(sm, mapFilter, experienceMarker) {

    if ( !mapFilter.includesExperience(experienceMarker.experience) ) {
        clearExperienceMarker(sm); // Clear away an existing experience marker selection.
        return;
    }

    clearMapBounds(sm);
    experienceMarker.onlineApp.prefetch(experienceMarker.experience.url);
    clearAuxResourceUrl(sm);
    clearAuxResourceName(sm);
    setExperienceMarker(sm, experienceMarker);
}
